export const urlParams = () => {
    // Check if any elements with vdx-url-param attribute exist on the page
    const urlParamElements = document.querySelectorAll('[vdx-url-param]');
    
    if (urlParamElements.length > 0 && window.location.search) {
        // get all url search params from the query string
        const urlParams = new URLSearchParams(window.location.search);
        
        // Process all URL params in a single pass
        urlParams.forEach((value, key) => {
            const elements = document.querySelectorAll(`[vdx-url-param="${key}"]`);
            
            // Immediately update elements if found
            elements.forEach(element => {
                if (element.tagName.toLowerCase() === 'input') {
                    element.value = value;
                } else {
                    element.textContent = value;
                }
            });
        });
    }

    // Find elements with vdx-param-* attributes more efficiently
    const paramElements = Array.from(document.querySelectorAll('*')).filter(element => {
        return Array.from(element.attributes).some(attr => attr.name.startsWith('vdx-param'));
    });
    
    if (paramElements.length > 0) {
        for (const element of paramElements) {
            // Add click event listener to elements
            element.addEventListener('click', function(e) {
                // Skip if element doesn't have href attribute
                if (!element.href) return;
                
                let paramsToAdd = '';
                let hasParams = false;
                
                // Process all matching attributes for this element
                for (const attr of element.attributes) {
                    if (attr.name.startsWith('vdx-param-')) {
                        const key = attr.name.substring(10);
                        if (!hasParams) {
                            paramsToAdd = `${key}=${encodeURIComponent(attr.value)}`;
                            hasParams = true;
                        } else {
                            paramsToAdd += `&${key}=${encodeURIComponent(attr.value)}`;
                        }
                    }
                }
                
                // Check for parent elements with vdx-param-* attributes
                let parentElement = element.parentElement;
                while (parentElement) {
                    for (const attr of parentElement.attributes) {
                        if (attr.name.startsWith('vdx-param-')) {
                            const key = attr.name.substring(10);
                            if (!hasParams) {
                                paramsToAdd = `${key}=${encodeURIComponent(attr.value)}`;
                                hasParams = true;
                            } else {
                                paramsToAdd += `&${key}=${encodeURIComponent(attr.value)}`;
                            }
                        }
                    }
                    parentElement = parentElement.parentElement;
                }
                
                // Only modify href if we have parameters to add
                if (hasParams) {
                    const separator = element.href.includes('?') ? '&' : '?';
                    element.href = element.href + separator + paramsToAdd;
                }
            });
        }
    }
}